import { Lead } from '@percihealth/react';
import LandgReferralForm from './LandgReferralForm';
import { LandgReferralNextSteps } from './LandgReferralNextSteps';

export default function Referral() {
  return (
    <>
      <main className="grid-outer main">
        <Lead title="L&G patient referral">
          <p>
            If you would like to refer your patients to Perci Health please fill
            out the form below.
          </p>
          <p>
            To make a referral, you will need consent from the patient and
            access to their key details.
          </p>
          <p>All details provided are encrypted and stored securely by us.</p>
        </Lead>
        <LandgReferralForm />
      </main>
      <LandgReferralNextSteps />
    </>
  );
}
